define([
	"dojo/json"
], function(json) {

	return {
		set: function (id, val, props) {
			// sets localStorage value if supported else fall back to cookie
			localStorage[id] = json.stringify(val);
		},

		get: function (id) {
			// returns localStorage value if supported else fall back to cookie
			var localStorageObj = localStorage[id];
			if (localStorageObj) {
				try {
					return json.parse(localStorageObj);
				} catch (err) {
					return localStorageObj;
				}
			}

			return null;
		},

		remove: function (id) {
			// deletes localStorage value if supported else delete the cookie
			localStorage.removeItem(id);
		}
	};
});
